type ParseSegments = {
  getIdByName: (name: string) => string;
};

export const parseSegments = (segments: string[]): ParseSegments => {
  const getIdByName = (name: string): string => {
    const index = segments.indexOf(name);

    return index > -1 ? segments[index + 1] : '';
  };

  return { getIdByName };
};
